import { ConversationItem, MessageItem, PublicUnseenMetrics, PublicUserDataModel } from '@appTypes/chat-api.types';
import { DataLoadStatusModel, RequestStateModel } from '@core/store/store.models';
import { ChatAttachmentUploadItem } from '../chat.type';

export class ChatMessageModel {
  messageId?: string;
  item?: MessageItem;
  ts?: number | null; // Helps to identify the message without ID, to update load state while sending
  loadState = new DataLoadStatusModel();
  attachmentsLoadState?: DataLoadStatusModel<{ id: string }>;
  attachmentsToUpload?: ChatAttachmentUploadItem[];
}
export class ChatBoxModel {
  id?: string;
  conversationId?: string;
  conversation?: ConversationItem;
  messages?: ChatMessageModel[];
  messagesCanLoadMore?: boolean;
  messagesisInitialLoad: boolean = true;
  messagesLoadState = new DataLoadStatusModel();
  isDraft?: boolean;
  loadState = new DataLoadStatusModel();
}

export class ConversationsListModel {
  items: ConversationItem[] = [];
  loadState = new DataLoadStatusModel();
  isInitialLoad: boolean = true;
  hasMore?: boolean;
  nextCursor?: string;
}

export class ChatStateModel {
  unseenMessagesCount = new RequestStateModel<PublicUnseenMetrics>();
  conversationsList = new ConversationsListModel();
  chatBoxes: ChatBoxModel[] = [];
  user: PublicUserDataModel | null = null;
  socketId: string | null = null;
}
